<template>
  <!-- eslint-disable max-len -->
  <div
    :style="{
      margin: '15px 0 20px',
      padding: indent ? '0 0 0 10px' : undefined,
    }"
  >
    <b-button
      v-if="name"
      v-b-toggle="name ? `collapse-${id ? id : name.replaceAll(/\s/g, '')}` : id"
      style="margin: 2px 0 7px; max-width: 100%; overflow: hidden;"
      :size="buttonSize"
      :style="buttonStyle"
    >
      <span
        :style="{
          'font-weight': (bold ? 'bolder' : undefined),
          'white-space': (ellipsis ? 'nowrap' : undefined),
          'text-overflow': (ellipsis ? 'ellipsis' : undefined),
          'overflow': (ellipsis ? 'hidden' : undefined),
          'height': (ellipsis ? 'fit-content' : undefined),
          'line-height': (ellipsis ? '112%' : undefined),
        }"
      >{{name}}</span>
    </b-button>
    <b-collapse
      v-model="valueWrapper"
      :id="name ? `collapse-${id ? id : name.replaceAll(/\s/g, '')}` : id"
      :class="`form-drawer ${collapseClass}`"
      :style="collapseStyle"
    >
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean },
    /** button text/section name; leave unspecified to create your own button elsewhere */
    name: { type: String },
    /** for associating the button and the collapse, needs to be unique */
    id: { type: String },
    buttonStyle: { type: Object },
    buttonSize: { type: String, default: 'sm' },
    /** convenient shorthand to make button text bold */
    bold: { type: Boolean },
    collapseStyle: { type: Object },
    collapseClass: { type: String },
    indent: { type: Boolean },
    /** keeps button to one line and truncates with ... */
    ellipsis: { type: Boolean },
  },
  computed: {
    valueWrapper: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-drawer {
  margin: 0 31px 10px 2px;
  padding-left: 20px;
  border-left: 1px solid rgb(165, 165, 165);
  border-bottom: 1px solid rgb(165, 165, 165);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/CollapsibleSection.vue